import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-question-toggle-parent',
    templateUrl: './question-toggle-parent.component.html',
    styleUrls: ['./question-toggle-parent.component.scss'],
    standalone: false
})
export class QuestionToggleParentComponent implements OnInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Input() itemQuestions: Question[] = [];
  @Input() showParent = true;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() saveChildrenQuestions = new EventEmitter<any>();

  childrenQuestions: Question[] = [];
  questionChanged = new Subject<Question>();

  constructor(private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    this.questionChanged.pipe(
      debounceTime(100)
    ).subscribe(x => {
      if (x) {
        this.saveAnswer(x);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question) {
        if (this.itemQuestions?.length) {
          this.childrenQuestions = this.itemQuestions;
        } else {
          this.getChildrenQuestion();
        }
        this.question.answer = 'Multiple answers';
        this.questionAnswer.emit(this.question);
      }
    }
  }

  getChildrenQuestion(): void {
    this.questionService.spinner(true);
    this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        for (const q of items) {
          if (!this.childrenQuestions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
            this.childrenQuestions.push(Object.assign({}, q));
          }
        }
        for (const q of this.childrenQuestions) {
          if (!q?.answer) {
            q.answer = 'false';
            this.saveAnswer(q);
          }
        }
        this.questionService.spinner(false);
      });
  }

  saveValue(value: Question, index: number): void {
    if (value?.answer) {
      value.answer = value.answer.toString();
      this.childrenQuestions[index] = value;
      this.questionChanged.next(value);
    }
    this.question.answer = 'Multiple answers';
    this.questionAnswer.emit(this.question);
  }

  saveAnswer(question: Question): void {
    this.questionService.saveAnswerOnly(question).subscribe();
  }

  ngOnDestroy(): void {
    this.questionChanged.next(undefined as any);
    this.questionChanged.complete();
  }

}
